/**
 * Phone numbers on the student profile and relatives are stored in 20-character
 * columns on the server. A longer value used to reach the database and come back as
 * a generic "Failed to save changes" (App Insights, 4 Sep 2026: a 21-digit paste).
 * The server now refuses it with a message; this mirrors that rule so the parent is
 * told before the request leaves the phone.
 */
export const MAX_PHONE_LENGTH = 20;

/** Digits, spaces, +, -, ( ) and . - the same set the server accepts. */
const ALLOWED = /^[0-9 +\-().]*$/;

/**
 * Null when the value is acceptable (blank counts as acceptable: it clears the
 * number), otherwise the sentence to show under the field.
 */
export function validatePhone(value: string | null | undefined, label = 'Phone'): string | null {
  const phone = (value ?? '').trim();
  if (phone.length === 0) return null;
  if (phone.length > MAX_PHONE_LENGTH) {
    return `${label} cannot be longer than ${MAX_PHONE_LENGTH} characters (you entered ${phone.length}).`;
  }
  if (!ALLOWED.test(phone)) {
    return `${label} may only contain digits, spaces, +, -, ( ) and .`;
  }
  return null;
}

/** Trimmed, or null for blank - the shape the profile endpoint expects. */
export const normalisePhone = (value: string | null | undefined): string | null => {
  const phone = (value ?? '').trim();
  return phone.length === 0 ? null : phone;
};
